import $ from "jquery";

$(document).on("turbolinks:load", function () {
  const containerSelectors = "body";
  if (!$("body").hasClass("demo-mode")) return;

  $(containerSelectors).find(".effective-datatable thead tr th, .dataTables_paginate, #left-sidebar").each(function () {
    $(this).append("<div class='demo-disable-table-header'></div>");
  });

  $(containerSelectors).find(".demo-disable-table-header, th, .filter-label").on("click mousedown mouseup", function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

  $("#left-sidebar .demo-disable-table-header").height($("#left-sidebar")[0].scrollHeight);
});
